export class Tipo {

    public id:number;
    public tipo:string;
    public valor:string;
    public descripcion:string;
    public codigoTipo:string;

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/tipo.ts